import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // --- FIX: Revert to importing the default App component ---

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* --- FIX: The Router is now inside App.js, so we just render App --- */}
    <App />
  </React.StrictMode>
);

